import {ComponentStyleConfig} from '@chakra-ui/react';

export const Popover: ComponentStyleConfig = {
  parts: ['popper', 'content', 'header', 'body', 'footer', 'closeButton'],
  // The styles all button have in common
  baseStyle: {
    content: {
      //boxShadow: 'rgb(230 230 230) 0px 6px 14px'
    },
    header: {
      // padding: '24px'
    },
    body: {
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }
  },
  variants: {
    secondary: {
      body: {
        padding: '24px'
      }
    }
  }
};
